<template lang="pug">
  b-row
    b-col
      b-tabs(content-class="mt-3")
        b-tab(title="Информация")
          Order_form(:order_data="order_data" :role="role")
        b-tab(title="Документы")
          document-list(
            :linked_id="order_data.data.id"
            linked_type="Order"
            :role="role"
            )
    b-col(cols="4")
      b-card(header="Чат с менеджером заказа")
        messages-list(:chat_id="order_data.data.attributes.chat_id" :role="role")

</template>

<script>

import Order_form from "./order_form";

import DocumentList from "../../../components/documents/DocumentList";
export default {
  name: "OrderPage",
  components: {Order_form, DocumentList},
  props: {
    role: {
      type: String,
      default: 'guest'
    },
    order_data: Object,

  },



}
</script>

<style scoped>

</style>